import React, { useState } from 'react';
import { use3DTilt } from '../../hooks/use3DTilt';
import './TiltCard.scss';

interface TiltCardProps {
  children: React.ReactNode;
  className?: string;
  shimmer?: boolean;
  spotlight?: boolean;
}

export const TiltCard: React.FC<TiltCardProps> = ({
  children,
  className = '',
  shimmer = true,
  spotlight = true,
}) => {
  const { ref, tilt, isHovered, handlers } = use3DTilt(8);
  const [mousePos, setMousePos] = useState({ x: 50, y: 50 });

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    handlers.onMouseMove(e);
    
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      setMousePos({ x, y });
    }
  };

  return (
    <div
      ref={ref}
      className={`tilt-card ${className} ${isHovered ? 'hovered' : ''}`}
      style={{
        transform: `perspective(1000px) rotateX(${tilt.rotateX}deg) rotateY(${tilt.rotateY}deg) scale3d(${tilt.scale}, ${tilt.scale}, 1)`,
        transition: isHovered ? 'none' : 'transform 0.5s ease',
        '--mouse-x': `${mousePos.x}%`,
        '--mouse-y': `${mousePos.y}%`,
      } as React.CSSProperties}
      onMouseMove={handleMouseMove}
      onMouseEnter={handlers.onMouseEnter}
      onMouseLeave={handlers.onMouseLeave}
    >
      {shimmer && <div className="shimmer-effect" />}
      {spotlight && <div className="spotlight-effect" />}
      <div className="tilt-content">{children}</div>
    </div>
  );
};
